import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {_AQH_EVE_12} from '../../../../../../../../../../@shared/models/input.module';
import {EventResponse} from '../../../../../../../../../../@shared/models/response.module';

@Component({
  selector: 'app-add-event-service',
  standalone: false,
  templateUrl: './add-event-service.html',
  styleUrl: './add-event-service.css'
})
export class AddEventService {
  @Input() event: EventResponse
  event_service_name: string = ''
  event_service_description: string = ''
  max_num_registrations: number
  price: number
  price_currency: string = 'NOK'


  constructor(private modal: NgbActiveModal,
              private eventService: EventsService) {
  }

  close() {
    this.modal.close();
  }

  addEvent() {
    let params: _AQH_EVE_12 = {
      event_id: this.event.event_id,
      event_service_name: this.event_service_name,
      event_service_description: this.event_service_description,
      max_num_registrations: this.max_num_registrations,
      price: this.price,
      price_currency: this.price_currency
    }
    this.eventService.addEventService(params).subscribe((data) => {
      console.log("Added Event Service: ", data);
      this.modal.close(true);
    });
  }
}
